import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../../presupuestos/utils';

const findByNumeroSolicitud = async (numero, { params }) => {
  return await axiosIns.get(obtenerUrl(`solicitudes/numero/${numero}`), { params });
};

const findOne = async (id, opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl(`solicitudes/${id}`), opciones);
};

export default {
  findByNumeroSolicitud,
  findOne,
};
